module.exports = __webpack_public_path__ + "img/02other-nizi2021.fccd67e1.png";